import React, { useState } from 'react';
import PostCard from '../components/PostCard';

function Kaydedilenler({ savedPosts = [], toggleSavePost }) {
  const [filter, setFilter] = useState('home');

  // "Home" artık ayrı bir üst küme değil, gerçek bir filtre: ne kod sorusu
  // ne sohbet konusu olan, sade Home akışındaki içerikler.
  const isCodeQuestion = (post) => Array.isArray(post.tags) && post.tags.includes('code-question');
  const isSohbetTopic = (post) => post.category?.slug === 'sohbet';
  const isHomePost = (post) => !isCodeQuestion(post) && !isSohbetTopic(post);

  const filteredItems = savedPosts.filter(post => {
    if (filter === 'home') return isHomePost(post);
    if (filter === 'code') return isCodeQuestion(post);
    if (filter === 'sohbet') return isSohbetTopic(post);
    return false;
  });

  // Sekmelerdeki dinamik sayı bildirimleri
  const homeCount = savedPosts.filter(isHomePost).length;
  const codeCount = savedPosts.filter(isCodeQuestion).length;
  const sohbetCount = savedPosts.filter(isSohbetTopic).length;

  return (
    <div className="saved-page" style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <header style={{ marginBottom: '24px' }}>
        <h1 style={{ fontSize: '24px', margin: '0 0 8px 0' }}>Kaydedilen Sorular & İçerikler</h1>
        <p style={{ color: 'var(--muted)', margin: 0, fontSize: '14px' }}>
          Toplam {savedPosts.length} içerikten {filteredItems.length} tanesi listeleniyor.
        </p>
      </header>

      {/* Kategorilere Göre Sekmeler (Tabs) — site menüsündeki sırayla aynı */}
      <div className="tabs" style={{ display: 'flex', gap: '10px', borderBottom: '1px solid var(--line)', marginBottom: '20px' }}>
        <button onClick={() => setFilter('home')} style={tabStyle(filter === 'home')}>
          Home ({homeCount})
        </button>
        <button onClick={() => setFilter('sohbet')} style={tabStyle(filter === 'sohbet')}>
          Sohbet ({sohbetCount})
        </button>
        <button onClick={() => setFilter('code')} style={tabStyle(filter === 'code')}>
          Code ({codeCount})
        </button>
      </div>

      {/* Kaydedilen Postların Listelendiği Alan */}
      <div className="saved-list">
        {filteredItems.length > 0 ? (
          filteredItems.map(post => (
            <div key={post.id || post.topic_id} style={{ marginBottom: '15px' }}>
              <PostCard 
                post={post} 
                toggleSavePost={toggleSavePost} 
                savedPosts={savedPosts} 
              />
            </div>
          ))
        ) : (
          <div style={{ textAlign: 'center', marginTop: '40px', color: 'var(--muted)', padding: '40px', background: 'var(--bg)', borderRadius: '8px', border: '1px dashed var(--line-strong)' }}>
            <p style={{ fontSize: '16px', margin: 0 }}>Bu kategoride kaydedilmiş bir içerik bulunmuyor...</p>
            <p style={{ fontSize: '13px', color: 'var(--muted)', marginTop: '8px' }}>
              Soruların veya tartışmaların sağ üstündeki kaydet butonuna basarak bu alana ekleyebilirsin.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

// Sekme Stil Dinamiği
const tabStyle = (isActive) => ({
  padding: '10px 18px',
  border: 'none',
  backgroundColor: 'transparent',
  borderBottom: isActive ? '3px solid var(--accent)' : '3px solid transparent',
  color: isActive ? 'var(--accent)' : 'var(--muted)',
  cursor: 'pointer',
  fontWeight: isActive ? '600' : 'normal',
  fontSize: '14px',
  transition: 'all 0.2s ease'
});

export default Kaydedilenler;